import type { RegisterOptions } from 'react-hook-form';

/** Scheduler contact names: required + min length; no letters-only pattern (ATT-1107). */
export const schedulerDefaultFirstNameRules: RegisterOptions = {
  required: 'First name is required',
  minLength: {
    value: 2,
    message: 'First name must be at least 2 characters',
  },
};

export const schedulerDefaultLastNameRules: RegisterOptions = {
  required: 'Last name is required',
  minLength: {
    value: 2,
    message: 'Last name must be at least 2 characters',
  },
};
